import { Ref } from 'react';
import PhoneInput from 'react-phone-number-input/input';
import { Input } from '../Input';
import { InputFieldProps } from '../types';

export { isValidPhoneNumber } from 'react-phone-number-input';

const DEFAULT_COUNTRY = 'CA' as const;
type SupportedCountry = typeof DEFAULT_COUNTRY | 'US';

type InputElement = HTMLInputElement;
export type PhoneNumberFieldProps = Omit<
  InputFieldProps,
  'onChange' | 'value' | 'defaultValue' | 'type' | 'ref'
> & {
  ariaLabel?: string;
  value?: string;
  defaultValue?: string;
  onChange?: (value: string) => void;
  defaultCountry?: SupportedCountry;
  ref?: Ref<InputElement>;
};

export const PhoneNumberField = ({
  intent,
  size,
  ariaLabel,
  disabled,
  name,
  onChange,
  autoComplete,
  defaultCountry = DEFAULT_COUNTRY,
  ref,
  ...restProps
}: PhoneNumberFieldProps) => {
  return (
    <PhoneInput
      {...restProps}
      inputComponent={Input}
      name={name}
      type="tel"
      size={size}
      intent={intent}
      disabled={disabled}
      aria-disabled={disabled}
      aria-label={ariaLabel}
      aria-invalid={intent === 'error'}
      defaultCountry={defaultCountry}
      useNationalFormatForDefaultCountryValue
      autoComplete={autoComplete ?? 'tel-national'}
      onChange={(value) => onChange?.(value ?? '')}
      ref={ref}
    />
  );
};
